import { ActionTypes } from './action-types.enum';

export const addGroups = (content) => ({
  type: ActionTypes.ADD_GROUPS,
  payload: {
    groups: content,
  }
});

export const addGroup = (content) => ({
  type: ActionTypes.ADD_GROUP,
  payload: {
    group: content,
  }
});

export const renameGroup = (content) => ({
  type: ActionTypes.RENAME_GROUP,
  payload: {
    data: content,
  }
});

export const deleteGroup = (id) => ({
  type: ActionTypes.DELETE_GROUP,
  payload: {
    id,
  }
});

export const setLastUsedGroup = (groupId) => ({
  type: ActionTypes.SET_LAST_USED_GROUP,
  payload: {
    groupId,
  }
});
